<template>
  <div>
    <vuetable :api-url="apiUrl" :css="css.table" :per-page="perPage" :append-params="moreParams" :http-options="tokenHeader" :fields="fields" data-path="data" pagination-path="" ref="vuetable" @vuetable:pagination-data="onPaginationData" :row-class="onRowClass" detail-row-component="joint-detail-row" detail-row-id="joint_id" track-by="joint_id" @vuetable:loading="loading" @vuetable:load-success="loadSuccess" @vuetable:cell-clicked="onCellClicked"></vuetable>
    <div class="vuetable-pagination">
      <vuetable-pagination-info class="pull-left" ref="paginationInfo" info-class="pagination-info"></vuetable-pagination-info>
      <vue-table-pagination-custom class="pull-right" ref="pagination" @vuetable-pagination:change-page="onChangePage"></vue-table-pagination-custom>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import VueTablePaginationCustom from './VueTablePaginationCustom'

export default {
  components: {
    VueTablePaginationCustom
  },
  props: {
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      required: true
    },
    moreParams: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'perPage'
    ])
  },
  data: function () {
    return {
      tokenHeader: {
        headers: {'Authorization': 'Bearer ' + this.$auth.token()}
      },
      css: {
        table: {
          tableClass: 'table table-striped',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
          renderIcon: function (classes, options) {
            return `<span class="${classes.join(' ')}"></span>`
          }
        }
      } // End CSS
    }
  },
  methods: {
    loading: function () {
      this.$notify({
        group: 'full',
        text: this.$t('Reloading data..'),
        position: 'top center'
      })
    },
    loadSuccess: function () {
      this.$notify({
        group: 'full',
        text: this.$t('Data reloaded'),
        position: 'top center'
      })
    },
    onRowClass: function (dataItem, index) {
      return 'data-row-' + dataItem.jointId
    },
    onChangePage: function (page) {
      this.$refs.vuetable.changePage(page)
    },
    onPaginationData: function (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onCellClicked: function (data, field, event) {
      console.log('triggered')
      this.$refs.vuetable.toggleDetailRow(data.data.joint_id)
    }
  },
  watch: {
    moreParams: function () {
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  events: {
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-reset' () {
      this.moreParams = {}
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  }
}
</script>



// WEBPACK FOOTER //
// JointVueTable.vue?254b9d15